import { post, fetch, Del, put } from "@/ask/axios";
import menberMenu from '@/components/userCenter/public/menberPageMenu.vue'
import desCountry from '@/components/userCenter/air/component/desCountry.vue'
import citySearch from '@/components/userCenter/air/component/citySearch.vue'
import endAirInput from '@/components/userCenter/air/component/endAirInput.vue'
import startCityeara from '@/components/userCenter/air/component/startCityeara.vue'
import startAirInput from '@/components/userCenter/air/component/startAirInput.vue'
import endInfoAdd from '@/components/userCenter/air/component/endInfoAdd.vue'
import contraband from '@/components/userCenter/public/contraband.vue'
import { Generalcargo } from '@/ask/util'
import { getCookie } from '@/ask/cookiejs'
import bus from '@/ask/eventBus'
import { getCustomer } from "@/utils/getCustomer";
export default {
  components: { menberMenu, startCityeara, startAirInput, citySearch, endInfoAdd, endAirInput, desCountry, contraband },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      titNames: "Air Freight Quotes",
      titUrls: "",
      isShowInquiryBtn: false,
      // 交互得到的数据
      CargoTypeIDs: [],//货物种类
      OrderServiceType: 3, //type Number   服务类型
      IsSHReport: '', // 有无化工报告 默认不勾选，选择未false和true
      IsDestCustoms: '',//type Boolean  目的地服务
      yzSuccess: false, //下单后为true 验证是否成功  用在从编辑回退时的判断

      //详细货物信息
      unitValue: 'CTNS',
      radCargo: [
        {
          Quanlity: '', Long: '', Wide: '', Height: '', High: '', Volume: '', Weight: '', LongIN: '', WideIN: '', HighIN: '', VolumeCFT: '', WeightLB: '', isCol1: false, isCol2: false, isCol3: false,
          unitOptions: [
            { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden Case' }, { value: 4, label: 'Other' }
          ],
          Unit: 1,
        },
      ],
      //总量信息计算
      unitOptions: [
        { value: 'CTNS', label: 'Carton' }, { value: 'PLTS', label: 'Pallet' }, { value: 'WOODEN CASE', label: 'Wooden Case' }, { value: 'OTHER', label: 'Other' }
      ],
      inputUnits: null, //输入件数
      inputWeight: null, //输入重量
      inputCBM: null, //输入总体积
      inputCFB: null,
      inputLB: null,

      //处理过的数据

      CargoNameCn: '',
      CargoNameEn: '',
      chkTerms: false,//是否阅读违禁品声明
      openTerms: false,//违禁品声明kuang


      // 设置地址
      setData: {
        City: {},
        AirPort: {},
        Country: '',
        desCity: {},
        desAirPort: {},
        desAllInfo: {},
      },

      BondTip: false,

      // 地址库得到的当前基本信息

      desCountryInfo: {
        CountryCode: ''
      },//type Object 保存接口当前数据,
      startCityInfo: {},
      desCityInfo: {},
      desAirPortInfo: {
        AirportCode3: null //该字段没有时给''
      },
      // 目的机场和国家的总和
      desAllInfo: {
        AirportCode3: null //该字段没有时给''
      },
      startAirPortInfo: {},

      //当前机场
      startAirPortArray: [],
      desAirPortArray: [],//机场

      curAddress: '', //保存当前的地址库信息

      curChannelList: null, //当前的渠道列表信息
      channelList: [],

      BondBox: false, //Bond 弹框
      BondValueInput: '', //这是Bond的输入值
      StroeBond: '', //存储Bond的值，防止关闭Bond弹框后改变BondValueInput
      BondType: '', //Bond类型
      IsBond: '', //是否选择Bond
      GoodsReadyTime: '',//货好时间
      QueryType: 2, //按每件计算还是货物重量计算，2：总量计算，1：每件计算
      VolumeUnit: 0,//计算单位 0：厘米，1：英寸

      stroeQuery: null,//存储查价条件

      Recent: {
        StartAir: [],
        StartCity: [],
        DestCountry: [],
        EndAir: [],
        EndAll: [],
        City: [],
        Time: '',
      },//最近查价




      //第二段
      // 筛选
      startAirPortCodes: [], //起飞和目的机场的筛选
      descAirPortCodes: [],
      selectThWorkDays: [], //时效筛选


      direct: '',
      leftQuery: true,//左边显示
      topQuery: true,//上边显示
      //分页
      currentPage: 1,//当前页数
      take: 5, //，每页显示的条数
      total: 0, //查询结果条数
      isShowpage: true,
      // 交互数据  End
      IsEnterLeave: null, //进出口权


      // 控制开关
      showQuery: false, // 查询显示
      showChannel: false, // 渠道显示
      IsSHReportCheck: false,//是否选了上海化工需要的货物check
      IsSHReportShow: false,
      isShowMore: true,//是否显示查看更多
      feeList: [], //报价详情展开[]代表没有展开
      orderSort: 'comprehensive',//排序
      //静态数据
      staticData: {
        LstDescAirPortCode3: [],
        LstStartAirPortCode3: [],
        lstThWorkDays: []
      },
      //验证提示
      checkTip: {
        startCity: '',
        startAirPort: '',
        desCountry: '',
        desCity: '',
        desAirPort: '',
        GoodsReadyTimeTip: '',
        CargoTypeIDsTip: '',
        IsDestCustomsTip: '',
        inputUnitsTip: '',
        inputWeightTip: '',
        inputCBMTip: '',
        inputCFBTip: '',
        inputLBTip: '',
        IsSHReport: '',
        desAllInfo: '',
      },

      // 处理后渲染的数据
      typeGoodsItemNo: '',//普货
      typeGoodsItemOften: '',//非普货
      // 接口数据

      //放送接口


      datePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },


      //--------查价列表--------//

      EnterShow: false,



      isDataNone: false,//是否有渠道数据
      isLoading: false,//加载中...
      isData: true,

      isWCA: false,
      IsCusOwnerType: true,//客户归属类型，跟客户类型区分开。null、0：直客，1：国内同行，2：海外同行 //海外同行的不显现Terminal to Door和Door to Door
      destSvc: [],
      Sum: {
        sumUnits: 0,
        sumKG: 0,
        sumLB: 0,
        sumCBM: 0,
        sumCFT: 0
      },
      //普货相关
      showNormalGoods: null,
      showOtherCar: false,

    };
  },

  created() {
    this.getRecent()
    this.AirPriceStoreQuery() //
    this.getTypeCargo()

    bus.$on('CusInfos', (Infos) => {
      if (Infos.CustomerOwnerType == 2) {
        this.IsCusOwnerType = false
      } else {
        this.IsCusOwnerType = true
      }

    })
  },
  mounted() {
    getCustomer().then((Customer) => {
      this.isWCA = Customer.IsWCA
      if (this.isWCA) {
        this.OrderServiceType = 2
      }
    }).catch((error) => {
    })
  },
  computed: {//计算属性周期函数
    //把选择LB单位，换算成KG,把选择CFT单位，换算成CBM,
    //sumUnits:'',sumKG:'',sumCBM:'',//总件数、总重量、总体积
    showStartAll() {
      let leftString = this.startAirPortCodes
      let rightString = this.staticData.LstStartAirPortCode3
      leftString = leftString ? leftString.sort().toString() : ''
      rightString = rightString ? rightString.sort().toString() : ''
      return leftString != rightString
    },
    showEndAll() {
      let leftString = this.descAirPortCodes
      let rightString = this.staticData.LstDescAirPortCode3
      // 如果不存在赋个初始值
      leftString = leftString ? leftString.sort().toString() : ''
      rightString = rightString ? rightString.sort().toString() : ''
      return leftString != rightString
    },
    sumUnit() { //件数总计
      let num = 0;
      if (this.radCargo) {
        this.radCargo.forEach(e => {
          num += (Number(e.Quanlity));
        });
        if (isNaN(num)) {
          return 0;
        }
      }
      this.Sum.sumUnits = num
      return num;
    },
    //KG单位换算
    sumKG() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * Number(e.Weight);
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * (Number(e.WeightLB) * 0.4535924);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumKG = num
      return num.toFixed(3);
    },
    //磅单位换算
    sumLB() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * (Number(e.Weight) * 2.2046226)
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * Number(e.WeightLB)
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumLB = num
      return num.toFixed(3);
    },
    // 起始地
    startQuery() {
      let curAddress = this.curAddress
      if ([3, 4].includes(this.OrderServiceType)
        && curAddress.startAirPortInfo.AirportCode3.length > 3) {
        return curAddress.startAirPortInfo.AirportNameEn
      }
      let oneAndTwo = `${curAddress.startCityInfo.CityNameEn},${curAddress.startCityInfo.Province_NameEn},${curAddress.startCityInfo.Country_NameEn}`
      let thirdAndFour = `${curAddress.startAirPortInfo.AirportCode3},${curAddress.startAirPortInfo.AirportNameEn}`
      return [oneAndTwo, oneAndTwo, thirdAndFour, thirdAndFour][this.OrderServiceType - 1]
    },
    // 目的地
    endQuery() {
      let curAddress = this.curAddress
      let oneAndFour = `${curAddress.desCityInfo.description},${curAddress.desCountryInfo.NameEn}`
      let twoAndThird = `${curAddress.desAllInfo.AirportCode3},${curAddress.desAllInfo.AirportNameEn}`
      return [oneAndFour, twoAndThird, twoAndThird, oneAndFour][this.OrderServiceType - 1]
    },
    //VolumeUnit=0 CBM；VolumeUnit=1 CFT
    //CBM单位换算
    sumCBM() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += (Number(e.Long) * Number(e.Wide) * Number(e.Height) / 1000000) * Number(e.Quanlity)
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += (Number(e.LongIN) * Number(e.WideIN) * Number(e.HighIN) * Number(e.Quanlity) * 0.000016387064)
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumCBM = num
      return num.toFixed(4);
    },
    sumCFT() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Long) * Number(e.Wide) * Number(e.Height) / 1000000 * Number(e.Quanlity) * 35.3147248
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += (((Number(e.LongIN) * Number(e.WideIN) * Number(e.HighIN)) * 0.000016387064 * 35.3147248) * e.Quanlity);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumCFT = num
      return num.toFixed(4);
    },


  },
  methods: {
    sendUserInfo(RedisKey) {
      this.api.url = this.$api01 + "/api/InfoCustomer/AirQueryNoResult/SaveAirNoAirportQueryData";
      this.api.param = {
        RedisKey: RedisKey,
        MobilePhone: this.$refs.desCountry.userInfo.Mail,
        Email: this.$refs.desCountry.userInfo.MobilePhone
      }
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          this.$alert('Currently unable to find the rate to this destination, we will inform you within three hours if there is available. ', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showClose: true,//去掉右上角的取消（X）
            center: true
          }).then(() => {
            this.CustomerInquiryAlert() //客户单询
          }).catch(() => {
            this.CustomerInquiryAlert() //客户单询
          });
        } else {
          this.CustomerInquiryAlert() //客户单询
        }
      });
    },
    BondBlur() {
      if (!this.BondValueInput) {
        this.BondTip = true
      } else {
        this.BondTip = false
      }
    },
    sureEnter() {
      if (this.IsEnterLeave == 1) {
        this.AirOrderEn()
      }
      this.EnterShow = false
    },

    // --------存储报价查价
    AirPriceStoreQuery() {
      if (this.$route.query.AirPirceStore == 1) {
        let AirPriceStore = sessionStorage.getItem('AirPriceStore');
        AirPriceStore = JSON.parse(AirPriceStore)
        let info = AirPriceStore.AirPriceStore
        this.OrderServiceType = info.OrderServiceType
        if (this.OrderServiceType == 3 || this.OrderServiceType == 4) {
          this.setData.AirPort = {
            AirportCode3: info.DepartureCode,
            AirportNameCh: info.DepartureName,
            AirportNameEn: info.DepartureNameEn
          }
        } else {
          this.setData.City = {
            CityKey: info.StartCityKey,
            CityNameCh: info.StartCityNameCn,
            CityNameEn: info.StartCityNameEn,
            CountryKey: info.StartCountryKey,
            Country_NameCh: info.StartCountryNameCn,
            Country_NameEn: info.StartCountryNameEn,
            ProvinceKey: info.StartProKey,
            Province_NameCh: info.StartProNameCn,
            Province_NameEn: info.StartProNameEn,
          }
        }
        if (this.OrderServiceType == 1 || this.OrderServiceType == 4) {
          this.setData.desCity = {
            DestAddressDesc: info.DestAddressDesc,
            lstTerms: info.AddrList,
            CountryEn: info.DestCountryNameEn
          }
        }
        if (this.OrderServiceType == 1 || this.OrderServiceType == 4) {
          this.setData.Country = info.DestCountryKey
        }

        if (this.OrderServiceType == 1 || this.OrderServiceType == 4) {
          this.setData.desAirPort = {
            AirportCode3: info.DestinationCode,
            AirportNameCh: info.DestinationName,
            AirportNameEn: info.DestinationNameEn,
          }
        } else {
          this.setData.desAllInfo = {
            AirportCode3: info.DestinationCode,
            AirportNameCh: info.DestinationName,
            AirportNameEn: info.DestinationNameEn,
            CountryNameCh: info.DestCountryNameCn,
            CountryNameEn: info.DestCountryNameEn,
          }
        }

        this.IsSHReport = info.IsSHReport// 有无化工报告 默认不勾选，选择未false和true
        this.IsDestCustoms = info.IsDestCustoms
        this.inputUnits = info.PackageQuanlity //输入件数
        this.inputWeight = info.Weight //输入重量
        this.inputCBM = info.VolumeCBM //输入总体积
        this.CargoTypeIDs = info.CargoIDs.split(',')
        let CurTime = new Date(new Date().toLocaleDateString()).getTime();
        if (new Date(info.PlanDeliveryTime).getTime() < CurTime) {
          this.GoodsReadyTime = ''
        } else {
          this.GoodsReadyTime = info.PlanDeliveryTime
        }
        for (let index = 0; index < this.CargoTypeIDs.length; index++) {
          this.CargoTypeIDs[index] = Number(this.CargoTypeIDs[index])
        }

      } else {
        //直客账户从首页查价把查询参数带过来赋值
        let queryItems = localStorage.getItem('queryItems');
        queryItems = JSON.parse(queryItems)
        // debugger
        if (queryItems) {
          this.setData.AirPort = queryItems.startItem
          this.setData.desAllInfo = queryItems.endItem

          this.inputUnits = this.$route.query.unitQty
          this.inputWeight = this.$route.query.weight
          this.inputCBM = this.$route.query.cbm;
          if (this.$route.query.cargoId) {
            this.CargoTypeIDs = this.$route.query.cargoId.split(',');
            for (var index = 0; index < this.CargoTypeIDs.length; index++) {
              this.CargoTypeIDs[index] = Number(this.CargoTypeIDs[index])
              if (this.CargoTypeIDs[index] == [sysCfg.air.Cargo.generalCargoID]) {
                this.NormalGoods(true);
                return;
              }
            }
          }

        }

      }
    },
    getDesv(res) {
      this.destSvc = res
    },
    // 重要功能
    RecentStore(Info) {
      let startAirIndex = -1
      let desAirIndex = -1
      let startCityIndex = -1
      let desCityIndex = -1
      let desCountryIndex = -1
      let desAllInfoIndex = -1
      for (let i = 0; i < this.Recent.StartAir.length; i++) {
        const ele = this.Recent.StartAir[i]
        if (ele.AirportCode3 == Info.startAirPortInfo.AirportCode3) {
          startAirIndex = i
        }
      }
      for (let i = 0; i < this.Recent.EndAir.length; i++) {
        const ele = this.Recent.EndAir[i]
        if (ele.List.AirportCode3 == Info.desAirPortInfo.AirportCode3) {
          desAirIndex = i
        }
      }
      for (let i = 0; i < this.Recent.StartCity.length; i++) {
        const ele = this.Recent.StartCity[i]
        if (ele.CityKey == Info.startCityInfo.CityKey) {
          startCityIndex = i
        }
      }
      for (let i = 0; i < this.Recent.City.length; i++) {
        const ele = this.Recent.City[i]
        if (ele.List.description == Info.desCityInfo.description) {
          desCityIndex = i
        }
      }
      for (let i = 0; i < this.Recent.DestCountry.length; i++) {
        const ele = this.Recent.DestCountry[i]
        if (ele.CountryCode == Info.desCountryInfo.CountryCode) {
          desCountryIndex = i
        }
      }
      for (let i = 0; i < this.Recent.EndAll.length; i++) {
        const ele = this.Recent.EndAll[i]
        if (ele.AirportCode3 == Info.desAllInfo.AirportCode3) {
          desAllInfoIndex = i
        }
      }
      if (Info.startAirPortInfo.AirportCode3) {
        if (startAirIndex !== -1) {
          this.Recent.StartAir.splice(startAirIndex, 1)
        } else {
          if (this.Recent.StartAir.length >= 20) {
            this.Recent.StartAir.splice(20, 1)
          }
        }
        this.Recent.StartAir.unshift(Info.startAirPortInfo)
      }
      if (Info.desAirPortInfo.AirportCode3) {
        if (desAirIndex !== -1) {
          this.Recent.EndAir.splice(desAirIndex, 1)
        } else {
          if (this.Recent.EndAir.length >= 20) {
            this.Recent.EndAir.splice(20, 1)
          }
        }
        this.Recent.EndAir.unshift({ 'List': Info.desAirPortInfo, 'Counrty': Info.desCountryInfo.CountryCode })
      }

      if (Info.startCityInfo) {
        if (startCityIndex !== -1) {
          this.Recent.StartCity.splice(startCityIndex, 1)
        } else {
          if (this.Recent.StartCity.length >= 20) {
            this.Recent.StartCity.splice(20, 1)
          }
        }
        this.Recent.StartCity.unshift(Info.startCityInfo)
      }
      if (Info.desAllInfo.AirportCode3) {
        if (desAllInfoIndex !== -1) {
          this.Recent.EndAll.splice(desAllInfoIndex, 1)
        } else {
          if (this.Recent.EndAll.length >= 20) {
            this.Recent.EndAll.splice(20, 1)
          }
        }
        this.Recent.EndAll.unshift(Info.desAllInfo)
      }
      if (Info.desCityInfo) {
        if (desCityIndex !== -1) {
          this.Recent.City.splice(desCityIndex, 1)
        } else {
          if (this.Recent.City.length >= 20) {
            this.Recent.City.splice(20, 1)
          }
        }
        this.Recent.City.unshift({ 'List': Info.desCityInfo, 'Counrty': Info.desCountryInfo.CountryCode })
      }
      if (Info.desCountryInfo && this.Recent.DestCountry.length < 20) {
        if (desCountryIndex !== -1) {
          this.Recent.DestCountry.splice(desCountryIndex, 1)
        } else {
          if (this.Recent.DestCountry.length >= 20) {
            this.Recent.DestCountry.splice(20, 1)
          }
        }
        this.Recent.DestCountry.unshift(Info.desCountryInfo)
      }
      this.Recent.Time = new Date()
      let obj = JSON.stringify(this.Recent)
      localStorage.setItem("En-recent-air", obj);
    },
    getRecent() {
      if (typeof (Storage) == undefined) {
        return false
      }
      if (localStorage.getItem("En-recent-air")) {
        this.Recent = JSON.parse(localStorage.getItem("En-recent-air"))
        let EndTime = new Date(new Date().setMonth(new Date(this.Recent.Time).getMonth() - 3))
        let Flag = new Date().getTime() - EndTime
        if (Flag < 0) {
          localStorage.removeItem('En-recent-air');
        }
      }
    },

    //查价
    clkEnquiry() {
      // 延时等待下拉框得blur事件
      setTimeout(() => {
        let num = 0
        this.radCargo.forEach(e => {
          num += (((Number(e.LongIN) * Number(e.WideIN) * Number(e.HighIN)) * 0.000016387064 * 35.3147248) * e.Quanlity);
        });

        let verification = this.Verification()
        if (!verification) {
          return false
        }
        if (!this.chkTerms) {
          this.openTerms = true//违禁品声明kuang
          return false
        }

        this.showQuery = true
        this.isLoading = true
        this.leftQuery = false
        this.topQuery = false
        // 存储当前地址 共下单使用
        this.CurAddress() //存储当前地址库
        this.StroeRadCargo = JSON.parse(JSON.stringify(this.radCargo))
        // 调用查价接口
        this.clkEnquiryAPI();
        this.RecentStore(this.curAddress)
      }, 200)
    },
    // 处理总计
    delTotal() {
      this.channelList.forEach(ele => {
        var STotalFee = 0
        var ETotalFee = 0
        for (var i = 0; i < ele.LstAirFee.length; i++) {
          STotalFee += Number(ele.LstAirFee[i].Amount)
        }
        for (var i = 0; i < ele.LstDestFee.length; i++) {
          ETotalFee += Number(ele.LstDestFee[i].Amount)
        }
        ele.STotalFee = STotalFee.toFixed(2)
        ele.ETotalFee = ETotalFee.toFixed(2)
      });
    },
    //下单
    enterBox(index, item) {
      this.curChannelList = this.channelList[index]
      if (this.desCountryInfo.NameCh != '美国' && (this.OrderServiceType == 1 || this.OrderServiceType == 4)) {
        this.EnterShow = true
      } else {
        this.AirOrderEn(item)
      }
    },
    //存储报价
    AirPriceStoreBox(index) {
      let _this = this
      this.$confirm('Are you sure you want to store the Price?', '', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        showCancelButton: true,//去掉取消按钮
        showClose: false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        _this.AirQueryPriceStore(index)
      }).catch(() => {
      });
    },
    // 编辑
    EditInfo() {
      this.showPu()
      this.isShowInquiryBtn = false
      this.feeList = []
      this.orderSort = 'comprehensive'
      ///重置只有直达
      this.direct = ''
      this.stroeQuery.ArrivalType = ''

      this.showQuery = false
      this.isShowMore = true
      this.radCargo = this.StroeRadCargo
      this.getRecent()
    },

    /** Tip Message  fn
     */
    eleAlert(Message, Tip, fn) {
      this.$confirm(Message, Tip, {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Not now',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        showCancelButton: true,//去掉取消按钮
        showClose: false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        fn()
      }).catch(() => {
      });
    },
    //弹大货单询框
    CustomerInquiryAlert() {
      // 计算计费重
      let weight = this.stroeQuery.TotalCBM * 1000000 / 6000
      let chargeWeight = this.stroeQuery.TotalWeight > weight
        ? Math.ceil(this.stroeQuery.TotalWeight)
        : Math.ceil(weight)
      if (chargeWeight >= 500
        || this.stroeQuery.CargoTypeIDs.includes(sysCfg.air.Cargo.batteryCargoID)
        || this.stroeQuery.CargoTypeIDs.includes(sysCfg.air.Cargo.porCargoID)
      ) {
        // 增加一个判断  需要对所有机场做判断 不准跳转大货单询
        if ([3, 4].includes(this.OrderServiceType) && this.curAddress.startAirPortInfo.AirportCode3.length > 3) {
          return false
        }
        // 对符合要求的条件进行处理
        this.isShowInquiryBtn = true
        let fn = this.CustomerInquiryFn
        this.eleAlert(
          `Your goods meet the requirements of making an inquiry to airline.
            Would you like to make an inquiry directly to airline for spot rate?`,
          '',
          fn)
      }
    },
    CustomerInquiryFn() {
      let customerInquiry = {
        stroeQuery: this.stroeQuery,
        curAddress: this.curAddress,
        CargoNameEn: this.CargoNameEn,
        CargoNameCn: this.CargoNameCn,
      }
      sessionStorage.setItem("customerInquiry", JSON.stringify(customerInquiry));
      let routeUrl = this.$router.resolve({
        path: "/myInquiry/customerInquiry",
      });
      window.open(routeUrl.href, '_blank');
    },
    VerificaAddress(arr) {
      let address = {
        startCity: this.startCityInfo.CityKey,
        startAirPort: this.startAirPortInfo.AirportCode3,
        desCountry: this.desCountryInfo.CountryCode,
        desCity: this.desCityInfo.description,
        desAirPort: this.desAirPortInfo.AirportCode3,
        desAllInfo: this.desAllInfo.AirportCode3
      }
      let Resolve = true
      arr.forEach(ele => {
        if (!address[ele]) {
          this.checkTip[ele] = 'Required'
          Resolve = false
        }
      });
      return Resolve
    },
    // 验证
    Verification() {
      let Resolve = true
      let adArr = [
        ['startCity', 'desCountry', 'desCity'],
        ['startCity', 'desAllInfo'],
        ['startAirPort', 'desAllInfo'],
        ['startAirPort', 'desCountry', 'desCity']
      ]
      let index = this.OrderServiceType - 1
      Resolve = this.VerificaAddress(adArr[index])
      if (this.OrderServiceType == 1 || this.OrderServiceType == 4) {
        if (this.IsDestCustoms === '') {
          this.checkTip.IsDestCustomsTip = 'Please choose whether you need destination customs clearance service or not!'
          Resolve = false
        }
      }

      if (!this.GoodsReadyTime) {
        this.checkTip.GoodsReadyTimeTip = 'Required'
        Resolve = false
      }

      if (!this.CargoTypeIDs.length) {
        this.checkTip.CargoTypeIDsTip = 'Please indicate which of the items listed below are included in your shipment.'
        Resolve = false
      }

      if (this.QueryType == 2) {
        if (this.VolumeUnit == 0) {
          ['inputUnits', 'inputWeight', 'inputCBM'].forEach(ele => {
            if (!this[ele]) {
              var Tip = `${ele}Tip`
              this.checkTip[Tip] = 'Required'
              Resolve = false
            }
          });
        } else {
          ['inputUnits', 'inputCFB', 'inputLB'].forEach(ele => {
            if (!this[ele]) {
              var Tip = `${ele}Tip`
              this.checkTip[Tip] = 'Required'
              Resolve = false
            }
          });
        }
      } else {
        if (this.VolumeUnit == 0) {
          this.radCargo.forEach(el => {
            if (!el.Height) {
              el.isCol1 = true
              Resolve = false
            }
            if (!el.Long || !el.Wide || !el.Quanlity) {
              el.isCol2 = true
              Resolve = false
            }
            if (!el.Weight) {
              el.isCol3 = true
              Resolve = false
            }
          });
        } else {
          this.radCargo.forEach(el => {
            if (!el.Quanlity) {
              el.isCol1 = true
              Resolve = false
            }
            if (!el.LongIN || !el.WideIN || !el.HighIN) {
              el.isCol2 = true
              Resolve = false
            }
            if (!el.WeightLB) {
              el.isCol3 = true
              Resolve = false
            }
          });
        }
      }

      if ((this.IsSHReportCheck && this.IsSHReportShow) && this.IsSHReport === '') {
        this.checkTip.IsSHReport = 'Required'
        Resolve = false
      }
      if (!Resolve) {
        return false
      } else {
        return true
      }
    },

    //处理数据
    //数据当前地址
    CurAddress() {
      let startAirPortInfo = {
        AirportCode3: null// 默认空
      }
      let desAllInfo = {
        AirportCode3: null// 默认空
      }
      let desAirPortInfo = {
        AirportCode3: null// 默认空
      }
      let startCityInfo = ''
      let desCityInfo = ''
      let desCountryInfo = ''
      if ([3, 4].includes(this.OrderServiceType)) {
        startAirPortInfo = this.startAirPortInfo
      } else {
        startCityInfo = this.startCityInfo
      }
      if ([1, 4].includes(this.OrderServiceType)) {
        desCityInfo = this.desCityInfo
      }
      if ([1, 4].includes(this.OrderServiceType)) {
        desCountryInfo = this.desCountryInfo
        desAirPortInfo = this.desAirPortInfo
      }
      if ([2, 3].includes(this.OrderServiceType)) {
        desAllInfo = this.desAllInfo
      }

      this.curAddress = {
        desCountryInfo: desCountryInfo,
        desCityInfo: desCityInfo,
        desAllInfo: desAllInfo,
        startCityInfo: startCityInfo,
        desAirPortInfo: desAirPortInfo,
        startAirPortInfo: startAirPortInfo,
        desAirPortArray: [],
        startAirPortArray: []
      }
      if (this.OrderServiceType == 3 || this.OrderServiceType == 4) {
        this.curAddress.startAirPortArray = this.startAirPortArray
      }
      if (this.OrderServiceType == 1 || this.OrderServiceType == 4) {
        if (this.desAirPortInfo.AirportCode3) {
          this.curAddress.desAirPortArray = [this.desAirPortInfo.AirportCode3]
        }
      } else {
        this.curAddress.desAirPortArray = [this.desAllInfo.AirportCode3]
      }
    },

    //筛选
    // @description: 筛选
    ClkSort(val) {
      this.isLoading = true
      this.leftQuery = false
      this.topQuery = true
      this.orderSort = val
      this.stroeQuery.OrderBy = val
      this.ScreenQuery(this.stroeQuery)
    },
    Screen() {
      this.isLoading = true
      this.leftQuery = true
      this.topQuery = true
      // if (this.startAirPortCodes.length == 0 || this.descAirPortCodes.length == 0 || this.selectThWorkDays.length == 0) {
        if (this.startAirPortCodes.length == 0 || this.descAirPortCodes.length == 0) {
        setTimeout(() => {
          this.isLoading = false
          this.channelList = []
        }, 1000)
      } else {
        this.stroeQuery.LstStartAirPortCode3 = this.startAirPortCodes
        this.stroeQuery.LstDestAirPortCode3 = this.descAirPortCodes
        this.stroeQuery.lstThWorkDays = this.selectThWorkDays
        this.ScreenQuery(this.stroeQuery)
      }
    },
    transChkAll(val) {
      if (val == 1) {
        this.startAirPortCodes = this.staticData.LstStartAirPortCode3
      } else {
        this.descAirPortCodes = this.staticData.LstDescAirPortCode3
      }
      this.Screen()
    },
    //仅此点击事件
    onlyTrans(code, index) {
      if (index == 2) {
        this.stroeQuery.LstDestAirPortCode3 = [code]
        this.descAirPortCodes = [code]
      } else {
        this.startAirPortCodes = [code]
        this.stroeQuery.LstStartAirPortCode3 = [code]
      }
      this.Screen();
    },
    OnlyDirect() {
      if (this.direct) {
        this.stroeQuery.ArrivalType = 1
      } else {
        this.stroeQuery.ArrivalType = ''
      }
      // this.isLoading = true
      // this.ScreenQuery(this.stroeQuery)
      this.Screen();
    },
    //筛选查价
    ScreenQuery(param, skip) {
      if (skip !== 'skip') {
        this.stroeQuery.Take = 5
        this.stroeQuery.Skip = 0
        this.take = 5
        this.currentPage = 1
        this.isShowMore = true //是否显示查看更多
      }
      this.feeList = []
      this.leftQuery = true
      this.topQuery = true
      this.api.url = this.$api01 + "/api/InfoCustomer/AirCalculation/QueryPriceEn";
      post(this.api.url, param).then((res) => {
        this.isLoading = false
        if (res.IsOK == true) {
          this.channelList = res.Results.List
          this.delTotal()
        } else {
          this.$message({
            type: 'error',
            message: res.Message
          });
        }
      })
    },
    //

    //@description: 分页
    channelPage(val) {
      this.isLoading = true
      this.currentPage = val
      this.stroeQuery.Skip = (this.currentPage - 1) * this.take
      this.ScreenQuery(this.stroeQuery, 'skip');
    },
    // 展开
    Openfee(Flagindex) {
      if (!this.feeList.length) {
        this.feeList.push(Flagindex)
        return
      }
      for (let i = 0; i < this.feeList.length; i++) {
        if (this.feeList[i] == Flagindex) {
          this.feeList.splice(i, 1)
          return
        }
      }
      this.feeList.push(Flagindex)
    },
    //默认显示5条，分页不显示，点击查看更多，展示一页20条
    clkMore() {
      this.isLoading = true
      this.feeList = []
      this.isShowMore = false //是否显示查看更多
      this.stroeQuery.Take = 20
      this.stroeQuery.Skip = 0
      this.take = 20
      this.currentPage = 1
      this.ScreenQuery(this.stroeQuery, 'skip');
    },
    prevClick() {
      this.isLoading = true
      this.currentPage--
      this.stroeQuery.Skip = (this.currentPage - 1) * this.take
      this.ScreenQuery(this.stroeQuery, 'skip');
    },
    nextClick() {
      this.isLoading = true
      this.currentPage++
      this.stroeQuery.Skip = (this.currentPage - 1) * this.take
      this.ScreenQuery(this.stroeQuery, 'skip');
    },

    //接口
    //@description:查价接口数据
    clkEnquiryAPI() {
      if (!this.IsBond) {
        this.BondType = ''
        this.BondValueInput = ''
      }
      //当选择货物信息时，只要包含了托盘，木箱和其他，就只显示托盘的价格
      //包材类型 1：纸箱，2：托盘
      let PackagingType = 1;
      ////详细
      if (this.QueryType == 1) {
        let newCarg = this.radCargo.some((e) => {
          return e.Unit != 1
        })
        if (newCarg) {
          PackagingType = 2;
        }
        if (this.VolumeUnit == 0) {
          this.radCargo.forEach(element => {
            element.LongIN = ''
            element.WideIN = ''
            element.HighIN = ''
            element.VolumeUnit = 0
            element.WeightLB = ''
            element.High = element.Height
          });
        } else {
          this.radCargo.forEach(element => {
            element.Long = element.LongIN * 2.54
            element.Wide = element.WideIN * 2.54
            element.High = element.HighIN * 2.54
            element.Height = element.HighIN * 2.54
            element.Weight = element.WeightLB * 0.4535924
            element.VolumeUnit = 1
          });
        }
      }

      // 总的货物
      let TotalQuanlity = ''
      let TotalWeight = ''
      let TotalCBM = ''
      if (this.QueryType == 2) {
        if (this.unitValue != "CTNS") {
          PackagingType = 2;
        }
        TotalQuanlity = Number(this.inputUnits)
        if (this.VolumeUnit == 1) {
          TotalCBM = Number(this.inputCFB * 0.0283168)
          TotalWeight = Number(this.inputLB * 0.4535924)
        } else {
          TotalWeight = Number(this.inputWeight)
          TotalCBM = Number(this.inputCBM)
        }
      } else {
        TotalQuanlity = this.Sum.sumUnits
        TotalWeight = this.Sum.sumKG
        TotalCBM = this.Sum.sumCBM
      }
      // Bond
      if (!this.IsDestCustoms) {
        this.IsBond = false
        this.BondType = ''
        this.BondValueInput = ''
      }

      if (this.OrderServiceType == 2 || this.OrderServiceType == 3) {
        this.IsBond = ''
        this.BondType = ''
        this.BondValueInput = ''
      }

      if (this.QueryType == 2) {
        this.radCargo = []
      }
      let LstDestinationTerms = []
      let DestCountryKey = ''
      let Destination = ''
      if ([1, 4].includes(this.OrderServiceType)) {
        DestCountryKey = this.curAddress.desCountryInfo.CountryKey
        Destination = this.desCityInfo.Primary_Description
        if (this.desCityInfo.lstTerms) {
          LstDestinationTerms = this.desCityInfo.lstTerms
        }
      } else {
        // DestCountryKey = this.curAddress.desAirPortInfo.
        DestCountryKey = this.curAddress.desAllInfo.CountryKey
      }


      this.getradCargoInfo() //货物种类

      //console.log('this.curAddress  '+ JSON.stringify(this.curAddress));

      let isGoods = true
      if (this.CargoTypeIDs == sysCfg.air.Cargo.generalCargoID) {
        isGoods = false
      } else if (!this.CargoTypeIDs) {
        isGoods = false
      }

      let typeText = ''
      if (this.OrderServiceType == 1) { typeText = 'Door to Door' }
      if (this.OrderServiceType == 2) { typeText = 'Door to Terminal', this.IsDestCustoms = false }
      if (this.OrderServiceType == 3) { typeText = 'Terminal to Terminal', this.IsDestCustoms = false }
      if (this.OrderServiceType == 4) { typeText = 'Terminal to Door' }

      let cargoArr = []
      if (this.CargoNameEn) {
        cargoArr = this.CargoNameEn.split(',')
      }

      let desCountry = ''
      if (this.OrderServiceType == 1 || this.OrderServiceType == 4) {
        desCountry = this.curAddress.desCountryInfo.NameEn
      } else if (this.OrderServiceType == 2 || this.OrderServiceType == 3) {
        desCountry = this.curAddress.desAllInfo.CountryNameEn
      }

      //this.checkPrice('Air Freight', this.startQuery, '', this.endQuery, desCountry, '',
      //Number(TotalWeight), Number(TotalCBM), Number(TotalQuanlity), isGoods, cargoArr, this.IsDestCustoms, typeText)

      this.api.param = {
        "OrderServiceType": this.OrderServiceType,
        "QueryGoodType": this.QueryType,
        "StartCityKey": this.curAddress.startCityInfo.CityKey,
        "DestCountryKey": DestCountryKey,
        "Destination": Destination,
        "LstDestinationTerms": LstDestinationTerms,
        "LstStartAirPortCode3": this.curAddress.startAirPortArray,
        "LstDestAirPortCode3": this.curAddress.desAirPortArray,
        "TotalQuanlity": TotalQuanlity,
        "TotalWeight": TotalWeight,
        "TotalCBM": TotalCBM,
        "GoodInfos": this.radCargo,
        "CargoTypeIDs": this.CargoTypeIDs,
        "GoodsReadyTime": this.GoodsReadyTime,
        "IsDestCustoms": this.IsDestCustoms,
        "ArrivalType": '',
        "IsBond": this.IsBond,
        "BondType": this.BondType,
        "BondValue": Number(this.BondValueInput),
        "IsSHReport": this.IsSHReport,
        "IsQueryDisableAirChannel": false,
        "lstThWorkDays": this.selectThWorkDays,
        "Skip": 0,
        "Take": 5,
        'PackagingType': PackagingType,
        "OrderBy": "comprehensive",
        "platformType": "web",
        "isLogin": true,
        "entrance": "Air Freight"
      }

      this.api.url = this.$api01 + "/api/InfoCustomer/AirCalculation/QueryPriceEn";
      this.stroeQuery = this.api.param
      post(this.api.url, this.api.param).then((res) => {

        this.searchResult(res.Results.Total, typeText, this.startQuery, '', this.endQuery, desCountry, false)

        if (res.IsOK == true) {
          Generalcargo(this.showNormalGoods, 2)
          this.channelList = res.Results.List
          this.delTotal()
          this.isLoading = false
          if (res.Results.List.length) {
            // 加载
            this.leftQuery = true
            this.topQuery = true
            //
            this.total = res.Results.Total
            this.staticData.LstDescAirPortCode3 = res.Results.LstDescAirPortCode3
            this.staticData.LstStartAirPortCode3 = res.Results.LstStartAirPortCode3
            this.staticData.lstThWorkDays = res.Results.lstThWorkDays


            this.startAirPortCodes = this.staticData.LstStartAirPortCode3
            this.descAirPortCodes = this.staticData.LstDescAirPortCode3
            this.selectThWorkDays = this.staticData.lstThWorkDays

          } else {
            this.leftQuery = false
            this.topQuery = false
          }
          let NotDestAirport = res.Results.NotDestAirport
          if (NotDestAirport) {
            this.sendUserInfo(res.Results.RedisKey) //没查到机场就掉接口
          } else {
            this.CustomerInquiryAlert() //客户单询
          }
        }
      })
    },
    // 下单接口
    AirOrderEn(item) {
      // console.log(item, "itemitem");
      let startCityInfo = this.curAddress.startCityInfo
      let desCountryInfo = this.curAddress.desCountryInfo
      let desCityInfo = this.curAddress.desCityInfo
      let VolumeCFT = Number(this.stroeQuery.TotalCBM) * 35.3147248
      let WeightLB = Number(this.stroeQuery.TotalWeight) * 2.2046226
      if (this.QueryType == 2 && this.VolumeUnit == 1) {
        VolumeCFT = this.inputCFB
        WeightLB = this.inputLB
      }
      let DestCountryKey = ''
      let DestCountryNameEn = ''
      let DestCountryNameCn = ''
      let DestAddressDesc = ''
      let LstDestinationTerms = []
      if ([1, 4].includes(this.OrderServiceType)) {
        DestCountryKey = desCountryInfo.CountryKey
        DestCountryNameEn = desCountryInfo.NameEn
        DestCountryNameCn = desCountryInfo.NameCh
        DestAddressDesc = desCityInfo.Primary_Description
        LstDestinationTerms = desCityInfo.lstTerms
      } else {
        // DestCountryKey = this.curAddress.desAirPortInfo.
        DestCountryKey = ''
        DestCountryNameEn = this.curAddress.desAirPortInfo.CountryNameEn
        DestCountryNameCn = this.curAddress.desAirPortInfo.CountryNameCh
      }
      this.api.param = {
        "Order": {
          "AirChannelKey": this.curChannelList.AirChannelKey,
          "AirCompanyKey": this.curChannelList.AirCompanyKey,
          "AirCompanyCode": this.curChannelList.AirCompanyCode2,
          "AirCompanyName": this.curChannelList.AirCompanyName,
          "DepartureCode": this.curChannelList.StartAirPortCode3,
          "DepartureName": this.curChannelList.StartAirportName,
          "DestinationCode": this.curChannelList.DestAirPortCode3,
          "DestinationName": this.curChannelList.DestAirportName,
          "FlightInfo": this.curChannelList.Flight,
          "ValidTerm": this.curChannelList.ValidTerm,
          "AirArrivalType": this.curChannelList.AirArrivalType,
          "OrderPrice": this.curChannelList.AirPrice,
          "OrderAmount": this.curChannelList.TotalFee,
          "OrderTrafficAmount": this.curChannelList.AirTracficFee,
          "OrderWeight": this.curChannelList.AirChargeWeight,
          "PackageUnit": this.unitValue,
          "SecondFlight": this.curChannelList.SecondFlight,
          "TransferAirport": this.curChannelList.TransferAirportCode3,
          "AirChannelName": this.curChannelList.AirChannelName,
          "DepartureNameEn": this.curChannelList.StartAirportNameEn,
          "DestinationNameEn": this.curChannelList.DestAirportNameEn,
          "AirCompanyCode3": this.curChannelList.AirCompanyCode3,
          "WeightLB": WeightLB,
          "VolumeCFT": VolumeCFT,
          "QueryGoodUnit": this.VolumeUnit,
          "Weight": this.stroeQuery.TotalWeight,
          "PackageQuanlity": Number(this.stroeQuery.TotalQuanlity),
          "VolumeCBM": Number(this.stroeQuery.TotalCBM),
          "PlanDeliveryTime": this.GoodsReadyTime,
          "OrderServiceType": this.OrderServiceType,
          "QueryGoodType": this.QueryType,
          "CargoIDs": this.stroeQuery.CargoTypeIDs.join(),
          "CargoNameCn": this.CargoNameCn,
          "CargoNameEn": this.CargoNameEn,
        },
        "OrderExt": {
          "StartCountryKey": "3c48f3d4-8f99-4721-9e88-2ff6f77b10bf",
          "StartCountryNameCn": "中国",
          "StartCountryNameEn": "China",
          "StartProKey": startCityInfo.ProvinceKey,
          "StartProNameCn": startCityInfo.Province_NameCh,
          "StartProNameEn": startCityInfo.Province_NameEn,
          "StartCityKey": startCityInfo.CityKey,
          "StartCityNameCn": startCityInfo.CityNameCh,
          "StartCityNameEn": startCityInfo.CityNameEn,
          "DestCountryKey": DestCountryKey,
          "DestCountryNameCn": DestCountryNameCn,
          "DestCountryNameEn": DestCountryNameEn,
          "DestAddressDesc": DestAddressDesc,
          "DestSvcID": this.curChannelList.DestSvcID,
          "THChannelKey": this.curChannelList.THChannelKey,
          "IsStartCustoms": null,
          "IsDestCustoms": this.stroeQuery.IsDestCustoms,
          "IsBond": this.stroeQuery.IsBond,
          "BondType": this.stroeQuery.BondType,
          "BondValue": this.stroeQuery.BondValue,
          "DestSvcID": this.curChannelList.DestSvcID,
          "OrderCostUnitPrice": item.CostUnitPriceTar, //成本单价(目标币种)
          "OrderCostCurrency": 2,//币种 英文网传美元
        },
        "GoodVolumeList": this.stroeQuery.GoodInfos,
        "DeliverOrder": {
          "DestSvcID": this.curChannelList.DestSvcID
        },
        "LstDestinationTerms": LstDestinationTerms,
        "FeeItem": this.curChannelList.LstAirFee.concat(this.curChannelList.LstDestFee),
      },
        this.api.url = this.$api03 + "/api/TradeCustomer/AirOrderEn/AddConfirmOrder";
      var newWindow = window.open()
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK == true) {


          // this.submitOrder(res.Results.WaybillNO, item.TotalFee, '', 'FREIGHT', this.startQuery, '', this.endQuery, '', this.CargoNameEn,
          //  this.stroeQuery.TotalWeight, this.stroeQuery.TotalCBM, this.stroeQuery.TotalQuanlity, item.AirChargeWeight, '', item.AirChannelName, item.AirTracficFee, '', '', false)

          // this.yzSuccess = true
          // this.$router.push({
          //   path: "/air/airEdit",
          //   query: {ord:res.Results.WaybillNO}
          // })
          newWindow.location.href = '/air/airEdit?ord=' + res.Results.WaybillNO
        } else {
          newWindow.close()
        }
      })
    },
    //存储报价接口
    AirQueryPriceStore(index) {
      this.curChannelList = this.channelList[index] //当前渠道
      let DestCountryKey = this.curAddress.desCountryInfo.CountryKey
      let DestCountryNameCn = this.curAddress.desCountryInfo.NameCh
      let DestCountryNameEn = this.curAddress.desCountryInfo.NameEn
      if (this.OrderServiceType == 2 || this.OrderServiceType == 3) {
        DestCountryKey = ''
        DestCountryNameEn = this.curAddress.desAllInfo.CountryNameEn
        DestCountryNameCn = this.curAddress.desAllInfo.CountryNameCh
      }
      this.api.url = this.$api03 + "/api/TradeCustomer/AirQueryPriceStore/SaveAirQueryPriceStore"
      this.api.param = {
        "StoreType": 1,
        "OrderServiceType": this.stroeQuery.OrderServiceType,
        "StartCountryKey": "3c48f3d4-8f99-4721-9e88-2ff6f77b10bf",
        "StartCountryNameCn": "中国",
        "StartCountryNameEn": "China",
        "LstDestinationTerms": this.stroeQuery.LstDestinationTerms,
        "StartProKey": this.curAddress.startCityInfo.ProvinceKey,
        "StartProNameCn": this.curAddress.startCityInfo.Province_NameCh,
        "StartProNameEn": this.curAddress.startCityInfo.Province_NameEn,
        "StartCityKey": this.curAddress.startCityInfo.CityKey,
        "StartCityNameCn": this.curAddress.startCityInfo.CityNameCh,
        "StartCityNameEn": this.curAddress.startCityInfo.CityNameEn,
        "StartCityAreaKey": this.curAddress.startCityInfo.CityAreaKey,
        "StartCityAreaNameCn": this.curAddress.startCityInfo.CityAreaNameCh,
        "StartCityAreaNameEn": this.curAddress.startCityInfo.CityAreaNameEn,
        "DestCountryKey": DestCountryKey,
        "DestCountryNameCn": DestCountryNameCn,
        "DestCountryNameEn": DestCountryNameEn,
        // "DestProKey":this.curAddress.desCityInfo.ProvinceKey ,
        // "DestProNameCn":this.curAddress.desCityInfo.Province_NameCh,
        // "DestProNameEn":this.curAddress.desCityInfo.Province_NameEn,
        // "DestCityKey":this.curAddress.desCityInfo.CityKey,
        // "DestCityNameCn":this.curAddress.desCityInfo.CityNameCh,
        // "DestCityNameEn": this.curAddress.desCityInfo.CityNameEn,
        "AirCompanyKey": this.curChannelList.AirCompanyKey,
        "AirCompanyCode": this.curChannelList.AirCompanyCode2,
        "AirCompanyName": this.curChannelList.AirCompanyName,
        "DepartureCode": this.curChannelList.StartAirPortCode3,
        "DepartureName": this.curChannelList.StartAirportName,
        "DepartureNameEn": this.curChannelList.StartAirportNameEn,
        "DestinationCode": this.curChannelList.DestAirPortCode3,
        "DestinationName": this.curChannelList.DestAirportName,
        "DestinationNameEn": this.curChannelList.DestAirportNameEn,
        "TransferAirPort": this.curChannelList.TransferAirportCode3,
        "PlanDeliveryTime": new Date(this.stroeQuery.GoodsReadyTime).Format('yyyy-MM-dd'),
        // "PlanDeliveryTime": "2019-08-20" ,
        "PackageQuanlity": this.stroeQuery.TotalQuanlity,
        "Weight": this.stroeQuery.TotalWeight,
        "VolumeCBM": this.stroeQuery.TotalCBM,
        "CargoIDs": this.stroeQuery.CargoTypeIDs.join(),
        "IsDestCustoms": this.stroeQuery.IsDestCustoms,
        "IsBond": this.stroeQuery.IsBond,
        "BondType": this.stroeQuery.BondType,
        // 这个BondValue 是 Bond内的输入的值
        "BondValue": this.stroeQuery.BondValue,
        "IsSHReport": this.stroeQuery.IsSHReport,
        "OrderTrafficAmount": this.curChannelList.AirTracficFee,
        "OrderAmount": this.curChannelList.TotalFee,
        "ValidTerm": this.curChannelList.ValidTerm,
        "PriceValidDate": this.curChannelList.AirValidEndTime,
        "ChannelKey": this.curChannelList.AirChannelKey,
        "ChannelName": this.curChannelList.AirChannelName,
        "AirCompanyCode3": this.curChannelList.AirCompanyCode3,
        "DestAddressDesc": this.desCityInfo.Primary_Description,
        "LstDestinationTerms": this.desCityInfo.lstTerms
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK) {
          this.$confirm('Saved successfully', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Go to view',
            cancelButtonText: 'Close',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: true,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            this.$router.push({
              path: "/myInfo/myAirPriceStore",
            })
          }).catch(() => {
          });
        } else {
          this.$alert('Saved fail', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            showClose: true,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
          }).catch(() => {
          });
        }
      })
    },
    //查询地区是否由上海化工报告
    IsSHRShow() {
      let StartAreaObj = this.startCityInfo
      //关联机场信息
      // this.api.url = this.$api01 + "/api/InfoCustomer/AddressPortRelation/QueryAddressPortRelation";
      this.api.url = this.$api04 + "/Air/api/AddressPortRelation/QueryAddressPortRelation";
      this.api.param = {
        "countryKey": StartAreaObj.CountryKey,
        "provinceKey": StartAreaObj.ProvinceKey,
        "cityKey": StartAreaObj.CityKey,
        "relationType": 1,
      }
      fetch(this.api.url, this.api.param).then((res) => {
        var AddressPortRelation = res.Results
        this.IsSHReportShow = AddressPortRelation.some(element => {
          return element.RelationCode === 'SHA' || element.RelationCode === 'PVG'
        });
      })
    },

    // 重要点击事件

    //处理货物种类的中英文格式
    getradCargoInfo() {
      this.CargoNameCn = []
      this.CargoNameEn = []
      //确保CargoTypeIDs是int型。不然走不进去
      this.CargoTypeIDs = this.CargoTypeIDs.map(item => {
        return +item;
      });
      for (let index = 0; index < this.typeGoodsItem.length; index++) {
        if (this.CargoTypeIDs.includes(this.typeGoodsItem[index].Id)) {
          this.CargoNameCn.push(this.typeGoodsItem[index].AttrVal_Content)
          this.CargoNameEn.push(this.typeGoodsItem[index].AttrVal_ContentEn)
        }
      }
      this.CargoNameCn = this.CargoNameCn.join()
      this.CargoNameEn = this.CargoNameEn.join()
    },
    resetChang() {
      this.radCargo.forEach((ele) => {
        ele.isCol1 = false
        ele.isCol2 = false
        ele.isCol3 = false
      })
      this.checkTip.inputUnitsTip = ''
      this.checkTip.inputWeightTip = ''
      this.checkTip.inputCBMTip = ''
      this.checkTip.inputCFBTip = ''
      this.checkTip.inputLBTip = ''
    },


    // 次要功能
    resetTip() {
      this.checkTip.startCity = ''
      this.checkTip.startAirPort = ''
      this.checkTip.desCountry = ''
      this.checkTip.desCity = ''
      this.checkTip.desAirPort = ''
      this.checkTip.GoodsReadyTimeTip = ''
    },
    // 打开Bond框
    openBond() {
      if (this.IsBond) {
        this.BondTip = false
        this.BondBox = true
      } else {
        this.BondValueInput = '' //这是Bond的输入值
        this.StroeBond = ''//存储Bond的值，防止关闭Bond弹框后改变BondValueInput
      }
    },
    BondClose() {
      if (this.StroeBond != this.BondValueInput) {
        this.BondValueInput = this.StroeBond
      }
      if (!this.BondValue) {
        this.IsBond = false
      }
      this.BondBox = false
    },
    getBondValue(BondType) {
      //验证是否输入
      var re = /^\d+(?=\.{0,1}\d+$|$)/
      if (!re.test(this.BondValueInput)) {
        this.BondValueInput = ''
      }
      if (!this.BondValueInput && BondType == 1) {
        this.BondValueInputTip = "tip"
        this.BondTip = true;
        return false
      }
      this.StroeBond = this.BondValueInput //存储该值
      //输入成功操作
      if (BondType == 2) {
        this.BondBox = false;
        this.BondValueInput = '';
        this.BondValue = 4000.00;
        this.BondType = 2;
      } else {
        this.BondBox = false;
        this.BondType = 1;
        (this.BondValueInput * 0.005 * this.Rate).toFixed(2) > 350.00 ? (this.BondValue = this.BondValueInput * 0.005 * this.Rate).toFixed(2) : this.BondValue = 350.00
      }
    },

    //包裹类型切换，赋值
    clkPacketType(val) {
      this.PacketType = val
      this.inputWeight = null
    },
    //点击增加图标
    addPackItem() {
      let opt = {
        Quanlity: '', Long: '', Wide: '', Height: '', High: '', Volume: '', Weight: '', LongIN: '', WideIN: '', HighIN: '', VolumeCFT: '', WeightLB: '', isCol1: false, isCol2: false, isCol3: false,
        unitOptions: [
          { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden Case' }, { value: 4, label: 'Other' }
        ],
        Unit: 1,
      }
      return opt
    },
    //货件信息
    addPackage() { //增加包裹
      this.radCargo.push(this.addPackItem())
    },
    delPackage(index) { //删除包裹
      if (this.radCargo.length > 1) {
        this.radCargo.splice(index, 1);
      }
    },

    //获取货物种类
    getTypeCargo() {
      this.api.param = {
        AttrMain_Code: "KYSHSpecial"
      };
      // this.api.url = this.$api01 + "/api/Attribute/QueryList";
      this.api.url = this.$api04 + "/Basics/api/Attribute/QueryList";
      post(this.api.url, this.api.param).then((res) => {

        this.typeGoodsItem = res.Results[0].valList;
        this.typeGoodsItem.forEach(item => {
          this.$set(item, 'Id', item.AttrVal_ID);
        })
        this.typeGoodsItemOften = this.typeGoodsItem.filter(item => {
          return item.AttrVal_Content !== "普货";
        });
        this.typeGoodsItemNo = this.typeGoodsItem.filter(item => {
          return item.AttrVal_Content == "普货";
        });
      });
      //this.showPu()
    },
    //起运城市组件取值
    byCityValue(msg) {
      // console.log('msg1  ' + JSON.stringify(msg))
      this.startCityInfo = msg
      if (!msg) {
        this.checkTip.startCity = 'Required'
      } else {
        this.checkTip.startCity = ''
      }
      if (this.startCityInfo) {
        this.IsSHRShow() //化工报告
      }

    },
    byEndCityValue(msg) {
      this.desCityInfo = msg
      if (!msg) {
        this.checkTip.desCity = 'Required'
      } else {
        this.checkTip.desCity = ''
      }
    },
    byAirPortValue(msg) {
      this.desAirPortInfo = msg
      if (this.OrderServiceType == 2 || this.OrderServiceType == 3) {
        if (!msg) {
          this.checkTip.desAirPort = 'Required'
        } else {
          this.checkTip.desAirPort = ''
        }
      } else {
        this.checkTip.desAirPort = ''
      }
    },
    byStartAirValue(msg) {
      this.startAirPortInfo = msg
      if (!msg) {
        this.checkTip.startAirPort = 'Required'
      } else {
        this.checkTip.startAirPort = ''
      }
      // 化工报告机场
      if (this.startAirPortInfo) {
        if (msg.AirportCode3 === 'SHA' || msg.AirportCode3 === 'PVG' || msg.AirportCode3.length > 3) {
          this.IsSHReportShow = true
        } else {
          this.IsSHReportShow = false
        }
        this.startAirPortArray = msg.AirportCode3.split(',')
      } else {
        this.startAirPortArray = []
      }
    },
    GetAllEndPort(msg) {
      this.desAllInfo = msg
      if (!msg) {
        this.checkTip.desAllInfo = 'Required'
      } else {
        this.checkTip.desAllInfo = ''
      }
    },
    //目的国家组件取值
    byCountryValue(msg) {
      //console.log(msg)
      this.desCountryInfo = msg
      if (!msg.CountryKey) {
        this.checkTip.desCountry = 'Required'
      } else {
        this.checkTip.desCountry = ''
      }
    },

    //yz
    goBlur(val) {
      var type = `${val}Tip`
      let cantZero = ['inputWeight', 'inputCBM', 'inputCFB', 'inputLB']
      if (cantZero.includes(val)) {
        if (Number(this[val]) <= 0) {
          this[val] = ''
          this.checkTip[type] = 'Required'
        }
      }
      if (!this[val]) {
        this.checkTip[type] = 'Required'
      } else {
        this.checkTip[type] = ''
      }
    },
    detailBlur(val, index) {
      //console.log(this.radCargo[index][val])
      if (val == 'Long' || val == 'Wide' || val == 'Height' || val == 'LongIN' || val == 'WideIN' || val == 'HighIN') {
        if (this.radCargo[index][val] == 0 || this.radCargo[index][val] == '.') {
          this.radCargo[index][val] = ''
        }
        if (this.radCargo[index][val] == '') {
          this.radCargo[index].isCol2 = true
        } else {
          this.radCargo[index].isCol2 = false
        }
      } else if (val == 'Quanlity') {
        if (this.radCargo[index][val] == 0 || this.radCargo[index][val] == '.') {
          this.radCargo[index][val] = ''
        }
        if (this.radCargo[index][val] == '') {
          this.radCargo[index].isCol1 = true
        } else {
          this.radCargo[index].isCol1 = false
        }
      } else if (val == 'Weight' || val == 'WeightLB') {
        if (this.radCargo[index][val] == 0 || this.radCargo[index][val] == '.') {
          this.radCargo[index][val] = ''
        }
        if (this.radCargo[index][val] == '') {
          // console.log(this.radCargo[index][val])
          this.radCargo[index].isCol3 = true
        } else {
          this.radCargo[index].isCol3 = false
        }
      }
    },
    //点击违禁品声明弹框
    clkContraband() {
      this.$refs.contraRef.clkOpenBox();
    },
    getUnit(unit, hasBill) {
      // 计费单位 目的地费用:（0：票，1：CBM，2：份，3：KG,4：页，5：单,6：天，7：次，8：件）
      switch (unit) {
        case 0:
          if (hasBill) {
            return 'Bill'
          }
          return 'B\\L'
        case 1:
          return 'CBM'
        case 2:
          return 'Pcs'
        case 3:
          return 'KG'
        case 4:
          return 'Page'
        case 5:
          if (hasBill) {
            return 'Bill'
          }
          return 'B\\L'
        case 6:
          return 'Day'
        case 7:
          return 'Time'
        case 8:
          return 'Unit'
      }
    },

    //-----

    //-------快递查价第一部分条件输入-------------//


    //  验证类
    checkNumInt(ctrValue) {
      if (ctrValue == 0) {
        ctrValue = '';
      }
      if (ctrValue) {
        ctrValue = ctrValue.replace(/\D/g, '');
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 4) {
          ctrValue = arr[0].substring(0, 4);
        }
      }
      return ctrValue;
    },
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 4);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 7) {
          let int = arr[0].substring(0, 7);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }

        return ctrValue;
      }
    },
    checkNumFour(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 4);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 7) {
          let int = arr[0].substring(0, 7);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }

        return ctrValue;
      }
    },
    // 普货点击
    NormalGoods(bool) {
      this.IsSHReportCheck = false
      if (this.showNormalGoods === bool) {
        this.showNormalGoods = null
        this.CargoTypeIDs = []
        return false
      }
      this.showNormalGoods = bool
      this.CargoTypeIDs = [sysCfg.air.Cargo.generalCargoID]

    },
    //普货相关
    showPu() {
      if (getCookie('En-Generalcargo')) {
        let Flag = (JSON.parse(getCookie('En-Generalcargo'))[2] === 1)
        if (Flag) {
          this.CargoTypeIDs = [sysCfg.air.Cargo.generalCargoID]
          this.showNormalGoods = false
        }
        //this.showOtherCar = Flag
      }
    },

    GoodsId(item) {
      this.showNormalGoods = null
      //判断之间的排斥关系
      if (item.Id === sysCfg.air.Cargo.generalCargoID || item.Id === sysCfg.air.Cargo.porCargoID || item.Id === sysCfg.air.Cargo.batteryCargoID) {
        this.CargoTypeIDs.forEach(element => {
          if (item.Id == element) {
            this.CargoTypeIDs = [element]
          }
        })
      } else {
        if (JSON.stringify(this.CargoTypeIDs) == JSON.stringify([sysCfg.air.Cargo.generalCargoID, item.Id]) || JSON.stringify(this.CargoTypeIDs) == JSON.stringify([sysCfg.air.Cargo.porCargoID, item.Id]) || JSON.stringify(this.CargoTypeIDs) == JSON.stringify([sysCfg.air.Cargo.batteryCargoID, item.Id])) {
          this.CargoTypeIDs = [item.Id]
        }
      }
      //化工报告需要配套电池和内置电池
      if (this.CargoTypeIDs.includes(sysCfg.air.Cargo.builtInBatID) || this.CargoTypeIDs.includes(sysCfg.air.Cargo.packedBatID)) {
        this.IsSHReportCheck = true
      } else {
        this.IsSHReportCheck = false
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/air/checkAirList.js